import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { ShareData } from 'src/app/app.share-data';
import { CheckPointService } from '../check-point/check-point.service';

@Injectable({
  providedIn: 'root'
})
export class NavigateService {

  mrpkBaseUrl = 'marketplace';
  contentID: any;
  route: any = {};
  current_lang = localStorage.getItem("language");

  constructor(
    private router: Router,
    private api: ApiService,
    private checkPoint: CheckPointService,
  ) { }

  navigateMenu(menu: any, isReload = false){
    this.router.navigateByUrl(menu).then(res =>{
      if(isReload) {
        window.location.reload();
      }
    });
  }

  navigateTo(service: any) {
    console.log('4444444444444444444444444444444444444444444');
    console.log(service);
    this.route = {};
    if (!service.DisplayAsList && (service && service.ContentList && service.ContentList[0])) {
      this.contentID = service.ContentList[0].ContentID;
    } else if (service.ContentID) {
      this.contentID = service.ContentID;
    } else {
      this.contentID = service.PageID;
    }

    if (!this.contentID) {
      this.contentID = service.RefID;
    }

    if (!service.DisplayAsList && !this.contentID) {
      this.contentID = service.ContentID || service.ServiceID;
    }

    this.sendServiceLogs(service, service.ServiceType || 'Page', this.contentID);

    if ('ServiceType' in service && service.ServiceType) {
      this.navigateByServiceType(service);
    } else if ('ContentType' in service && service.ContentType) {
      this.navigateByContentType(service);
    } else {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      } else {
        ShareData.currentMessage = service;
        // this.navigateToPage(`notification-view/${service.MessageID}/${service.isToday}`, null);
        this.route.type = 'notification-view';
        this.route.id = service.MessageID;
        this.route.isToday = service.isToday;
        this.route.path = `notification-view/${service.MessageID}/${service.isToday}`;
      }
    }
   
    return this.route;
  }

  sendServiceLogs(service: any, contentType: any, contentId: any, action: any = null) {
    this.api.sendServiceLogs(
      this.api.token as string
      , service.ServiceCode
      , contentType
      , contentId
      , action
    ).subscribe(res => {
      setTimeout(() => {
        this.checkPoint.checkPoint();
      }, 2000);
    }, err => {
      console.error('Send logs error: ', err);
    });
  }

  private navigateByServiceType(service: any) {
    let page = '';
    if (service.ServiceType.toLowerCase() === 'parent' || service.ServiceType.toLowerCase() === 'sub-parent') {
      page = `/services/${service.ServiceCode}`;
      this.route.type = 'service';
      this.route.serviceCode = service.ServiceCode;
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'news') {
      page = `/news/${service.ServiceCode}`;
      if (!service.DisplayAsList && service.NewsList && service.NewsList.length > 0) {
        page = `/news-detail/${service.NewsList[0].NewsID}`;
        this.route.type = 'news-detail';
        this.route.id = service.NewsList[0].NewsID;
        this.route.serviceCode = service.ServiceCode;
        this.route.path = page;
        return;
      }
      this.route.type = 'news';
      this.route.serviceCode = service.ServiceCode;
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'page') {
      page = `/content/${service.ServiceCode}`;
      if (!service.DisplayAsList && service.ContentList && service.ContentList.length > 0) {
        page = `/content-detail/${service.ContentList[0].ContentID}`;
        this.route.type = 'content-detail';
        this.route.serviceCode = service.ServiceCode;
        this.route.id = service.ContentList[0].ContentID;
        this.route.path = page;
        return;
      }
      
      this.route.type = 'content';
      this.route.serviceCode = service.ServiceCode;
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'activity') {
      page = `/activity/${service.ServiceCode}`;
      if (!service.DisplayAsList && service.ActivityList && service.ActivityList.length > 0) {
        page = `/activity-detail/${service.ActivityList[0].ActivityID}`;
        this.route.type = 'activity-detail';
        this.route.serviceCode = service.ServiceCode;
        this.route.id = service.ActivityList[0].ActivityID;
        this.route.path = page;
        return;
      }
      this.route.type = 'activity';
      this.route.serviceCode = service.ServiceCode;
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'reward') {
      page = '/reward';
      if('RefID' in service) {
        this.route.id = service.RefID;
      }
      this.route.type = 'reward';
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'external') {
      this.setPathWithWebURL(service);
    } else if (service.ServiceType.toLowerCase() === 'link') {
      this.setPathWithWebURL(service);
    } else if (service.ServiceType.toLowerCase() === 'marketplace') {
      page = `${this.mrpkBaseUrl}/home`;
      this.route.type = 'marketplace';
      this.route.path = page;
    }  else if (service.ServiceType.toLowerCase() === 'reel') {
      page = `video`;
      this.route.type = 'reel';
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'leaderboard') {
      page = `points-leaderboard`;
      this.route.type = 'leaderboard';
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'coursehistory' || service.ServiceType.toLowerCase() === 'course-history') {
      page = `course-history`;
      this.route.type = 'course-history';
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'mypoints' || service.ServiceType.toLowerCase() === 'my-points') {
      page = `mypoints`;
      this.route.type = 'mypoints';
      this.route.path = page;
    } else if (service.ServiceType.toLowerCase() === 'pointtransfer' || service.ServiceType.toLowerCase() === 'point-transfer') {
      page = `point-transfer`;
      this.route.type = 'point-transfer';
      this.route.path = page;
    } else if (
      service.ServiceType.toLowerCase() === 'survey' ||
      service.ServiceType.toLowerCase() === 'servey' ||
      service.ServiceType.toLowerCase() === 'survey online' ||
      service.ServiceType.toLowerCase() === 'servey online'
    ) {
      page = `/survey`;
      this.route.type = 'survey';
      if (this.contentID) {
        this.route.id = this.contentID;
      }
      this.route.path = page;
    }else {
      if (service.URL && service.URL.indexOf('http') !== -1) {
        this.setPathWithWebURL(service);
      }
    }
  }

  private navigateByContentType(service: any) {
    let page = '';
    const contentKey = service.ReferentContentKey || service.ContentID|| service.ContentId || service.RefID;
    if (service && service.ContentType.toLowerCase() === 'activity') {
      page = `activity-detail/${contentKey}/1`;
      this.route.type = 'activity-detail';
      this.route.id = contentKey;
      this.route.path = page;
    } else if (service && service.ContentType.toLowerCase() === 'news') {
      page = `/news-detail/${contentKey}`;
      this.route.type = 'news-detail';
      this.route.id = contentKey;
      this.route.path = page;
    } else if (service && service.ContentType.toLowerCase() === 'page') {
      page = `/content-detail/${contentKey}`;
      this.route.type = 'content-detail';
      this.route.id = contentKey;
      this.route.path = page;
    } else if (service && service.ContentType && service.ContentType.toLowerCase() === 'leaderboard') {
      page = `points-leaderboard`;
      this.route.type = 'leaderboard';
      this.route.path = page;
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'coursehistory' ||
                service.ContentType.toLowerCase() === 'course-history')) {
      page = `course-history`;
      this.route.type = 'course-history';
      this.route.path = page;
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'mypoints' ||
                service.ContentType.toLowerCase() === 'my-points')) {
      page = `mypoints`;
      this.route.type = 'mypoints';
      this.route.path = page;
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'pointtransfer' ||
                service.ContentType.toLowerCase() === 'point-transfer')) {
      page = `point-transfer`;
      this.route.type = 'point-transfer';
      this.route.path = page;
    } else if ('RedirectType' in service && service.RedirectType) {
      this.navigateByRedirectType(service);
    } else if (service.ContentType.toLowerCase() === 'reward') {
      page = '/reward';
      if('RefID' in service) {
        this.route.id = service.RefID;
      }
      this.route.type = 'reward';
      this.route.path = page;
    } else {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    }
  }

  private navigateByRedirectType(service: any) {
    let page = '';
    if (service.RedirectType === 'REDIRECT_BROWSER') {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    } else if (service.RedirectType === 'REDIRECT_EXTERNAL_APP') {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    } else if (service.RedirectType === '0') {
      if (service && service.ContentType === 'MarketplaceInterestInfo') {
        page = `marketplace-interested-info`;
        this.route.type = 'marketplace-interested-info';
        this.route.id = service.ReferentContentKey;
        this.route.path = page;
      } else if (service && service.ContentType === 'MarketplaceComment') {
        page = `marketplace-my-product-detail`;
        this.route.type = 'marketplace-my-product-detail';
        this.route.id = service.ReferentContentKey;
        this.route.path = page;
      } else if(service && service.ContentType === 'COMMON') {
        ShareData.currentMessage = service;
        this.route.type = 'notification-view';
        this.route.id = service.MessageID;
        this.route.isToday = service.isToday;
        this.route.path = `notification-view/${service.MessageID}/${service.isToday}`;
      } 
    }
  }

  public navigateToPage(page: any, q?: Object) {
    this.router.navigate([page], {queryParams: q});
  }

  public navigateToUrl(baseUrl: string){
    window.open(baseUrl, '_blank');
  }

  tryInternalNavigation(url: string): boolean {
    if (!url) return false;
    
    let path = url;
    const doubleSlashIndex = url.indexOf('//');
    if (doubleSlashIndex !== -1) {
      const nextSlashIndex = url.indexOf('/', doubleSlashIndex + 2);
      if (nextSlashIndex !== -1) {
        path = url.substring(nextSlashIndex);
      } else {
        path = '/';
      }
    }
    
    if (path.indexOf('/web/') === 0) {
      path = path.substring(4);
    } else if (path.indexOf('/web') === 0) {
      path = path.substring(4);
    }
    
    if (path.indexOf('/') !== 0) {
      path = '/' + path;
    }
    
    const internalRoutes = [
      '/news-detail',
      '/content-detail',
      '/activity-detail',
      '/points-leaderboard',
      '/course-history',
      '/mypoints',
      '/my-points',
      '/point-transfer',
      '/home',
      '/reward',
      '/marketplace',
      '/news',
      '/content',
      '/activity',
      '/profile',
      '/notification-view',
      '/notification-list',
      '/favorite-list'
    ];
    
    for (const route of internalRoutes) {
      if (path.indexOf(route + '?') === 0 || path === route || path.indexOf(route + '/') === 0) {
        this.router.navigateByUrl(path);
        return true;
      }
    }
    
    return false;
  }

  public navigateToUrlAndCheckToken(url: string){
    if (this.tryInternalNavigation(url)) {
      return;
    }
    if (url.indexOf('points-leaderboard') !== -1) {
      this.router.navigate(['/points-leaderboard']);
      return;
    }
    if (url.indexOf('course-history') !== -1) {
      this.router.navigate(['/course-history']);
      return;
    }
    if (url.indexOf('mypoints') !== -1 || url.indexOf('my-points') !== -1) {
      this.router.navigate(['/mypoints']);
      return;
    }
    if (url.indexOf('point-transfer') !== -1) {
      this.router.navigate(['/point-transfer']);
      return;
    }
    const webEndpointURL = (url.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(url) : url;
    console.log(webEndpointURL);
    this.navigateToUrl(webEndpointURL);
  }

  setPathWithWebURL(service: any){
    console.log(service);
    const url = service.WebURL || service.URL;
    if(!url) {
      console.error('Url is emty', service);
      return;
    }
    if (this.tryInternalNavigation(url)) {
      return;
    }
    if (url.indexOf('points-leaderboard') !== -1) {
      this.router.navigate(['/points-leaderboard']);
      return;
    }
    if (url.indexOf('course-history') !== -1) {
      this.router.navigate(['/course-history']);
      return;
    }
    if (url.indexOf('mypoints') !== -1 || url.indexOf('my-points') !== -1) {
      this.router.navigate(['/mypoints']);
      return;
    }
    if (url.indexOf('point-transfer') !== -1) {
      this.router.navigate(['/point-transfer']);
      return;
    }
    const webEndpointURL = (url.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(url) : url;
    this.navigateToUrl(webEndpointURL);
  }

  setPathWithRedirectPath(service: any){
    console.log(service);
    const path = service.RedirectPath;
    if(!path) {
      return;
    }
    if (this.tryInternalNavigation(path)) {
      return;
    }
    if (path.indexOf('points-leaderboard') !== -1) {
      this.router.navigate(['/points-leaderboard']);
      return;
    }
    if (path.indexOf('course-history') !== -1) {
      this.router.navigate(['/course-history']);
      return;
    }
    if (path.indexOf('mypoints') !== -1 || path.indexOf('my-points') !== -1) {
      this.router.navigate(['/mypoints']);
      return;
    }
    if (path.indexOf('point-transfer') !== -1) {
      this.router.navigate(['/point-transfer']);
      return;
    }
    const webEndpointURL = (path.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(path) : path;
    this.navigateToUrl(webEndpointURL);
  }

  checkRedirect(url: any) {
    console.log('xxxxxxxx');
    if(url.indexOf('authen?redirect=') !== -1) {
      url = `${url}&token=${this.api.token}&token_type=${this.api.tokenType}&type=${this.api.type}&access_token=${this.api.accessToken}&lang=${this.current_lang}`;
    } 
    else if(url.indexOf('course') !== -1) {
      url = url;
    }
    else if(
      url.indexOf('/web/') !== -1 ||
      url.indexOf('/web') !== -1 ||
      url.indexOf('news-detail') !== -1 ||
      url.indexOf('content-detail') !== -1 ||
      url.indexOf('activity-detail') !== -1 ||
      url.indexOf('mypoints') !== -1 ||
      url.indexOf('my-points') !== -1 ||
      url.indexOf('points-leaderboard') !== -1 ||
      url.indexOf('course-history') !== -1 ||
      url.indexOf('point-transfer') !== -1
    ) {
      url = url;
    }
     else {
      const separator = url.endsWith('/') ? '' : '/';
      url = `${url}${separator}authen?token=${this.api.token}&token_type=${this.api.tokenType}&type=${this.api.type}&access_token=${this.api.accessToken}&lang=${this.current_lang}`;
    }
    return url;
  }

  openNewTab(baseUrl: string){
    window.open(baseUrl, '_blank');
  }

  highlightOpenNewsList(service: any) {
    // this.navigateToPage(`/news/${service.ServiceCode}`, {page: 1});
    this.route.type = 'news';
    this.route.serviceCode = service.ServiceCode;
    this.route.path = `/news/${service.ServiceCode}`;
    return this.route;
  }

  highlightOpenNews(service: any) {
    // this.navigateToPage(`/news-detail/${service.ContentID || service.RefID}`);
    this.route.type = 'news-detail';
    this.route.id = service.ContentID || service.RefID;
    this.route.path = `/news-detail/${service.ContentID || service.RefID}`;
    return this.route;
  }

  highlightOpenPageList(service: any) {
    // this.navigateToPage(`/content/${service.ServiceCode}`);
    this.route.type = 'content';
    this.route.serviceCode = service.ServiceCode;
    this.route.path = `/content/${service.ServiceCode}`;
    return this.route;
  }

  highlightOpenPage(service: any) {
    // this.navigateToPage(`/content-detail/${service.ContentID || service.RefID}`);
    this.route.type = 'content-detail';
    this.route.id = service.ContentID || service.RefID;
    this.route.path = `/content-detail/${service.ContentID || service.RefID}`;
    return this.route;
  }

  highlightOpenRewardList(service?: any) {
    // this.navigateToPage(`/reward`);
    this.route.type = 'reward';
    this.route.path = `/reward`;
    return this.route;
  }

  highlightOpenReward(service: any) {
    // this.navigateToPage(`/reward`, {rewardId: service.RefID || service.RefID});
    this.route.type = 'reward';
    this.route.id = service.ContentID || service.RefID;
    this.route.path = `/reward?id=`+(service.RefID || service.ContentID) ;
    return this.route;
  }

  highlightOpenLink(service: any) {
    let url = service.WEB_URL || service.URL;
    if(!url) {
      console.error('Url is emty', service);
      return;
    }
    const webEndpointURL = (url.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(url) : url;
    this.navigateToUrl(webEndpointURL);
  }

  highlightOpenActivity(service: any) {
    // this.navigateToPage(`/activity/${service.ServiceCode}`);
    this.route.type = 'activity';
    this.route.serviceCode = service.ServiceCode;
    this.route.path = `/activity/${service.ServiceCode}`;
    return this.route;
  }

  highlightOpenActivityDetail(service: any) {
    // this.navigateToPage(`/activity-detail/${service.ContentID || service.RefID}/1`);
    this.route.type = 'activity-detail';
    this.route.id = service.ContentID || service.RefID;
    this.route.path = `/activity-detail/${service.ContentID || service.RefID}`;
    return this.route;
  }

  highlightOpenParent(service: any) {
    // this.navigateToPage(`/services/${service.ServiceCode}`);
    this.route.type = 'service';
    this.route.serviceCode = service.ServiceCode;
    this.route.path =`/service/${service.ServiceCode}`;
    return this.route;
  }

  highlighOpenMarketplace(service: any) {
    // this.navigateToPage(`${this.mrpkBaseUrl}/home`);
    this.route.type = 'marketplace';
    this.route.path = `${this.mrpkBaseUrl}/home`;
    return this.route;
  }
}
